module.exports = __webpack_public_path__ + "img/icon_download@2x.8ec31312.png";